const company = {
  company: {
    pageHeader: 'Perfil da empresa',
    branchProfile: 'Perfil de filial',
    addBranchOffice: 'Adicionar filial',
    companyDetails: 'Detalhes da Empresa',
    branchDetails: 'Detalhes da filial',
    companyName: 'Nome da empresa',
    branchName: 'Nome da Filial',
    websiteURL: 'URL do site',
    url: 'URL',
    yearFounded: 'Ano de fundação',
    companyLogo: 'Logotipo da Empresa',
    imageFormatDescription: 'Deve ser um arquivo JPEG, GIF ou PNG de até 4 MB.',
    imageShapeDescription:
      'Para melhores resultados, recomendamos uma imagem quadrada com fundo transparente de pelo menos 400 px de largura por 400 px de altura.',
    noFile: 'Nenhum arquivo selecionado',
    companyDescription: 'Descrição da Empresa',
    myTestEdit: 'Minha edição de teste',
    customerWelcomeEmail: 'Mensagem de e-mail de boas-vindas ao cliente',
    testEditMessage: 'teste editar mensagem de e-mail',
    companyDescriptionTooltip:
      'O texto inserido aqui aparecerá nas visualizações públicas dos sistemas instalados por sua empresa. Você pode incluir informações de contato para ajudar a gerar leads de vendas dos visitantes dessas páginas.',
    editCompanyInformation: 'Editar informações da empresa',
    welcomeEmailDescription:
      'O texto inserido aqui aparecerá no e-mail de boas-vindas enviado aos novos clientes quando uma conta do Enlighten é criada. Você pode optar por incluir o logotipo de sua empresa com esta mensagem.',
    editWelcomeMessage: 'Editar mensagem de e-mail de boas-vindas ao cliente',
    checkboxDisplayLogo: 'Exibir o logotipo da empresa no e-mail de boas-vindas ao cliente',
    previewEmail: 'Visualizar e-mail de boas-vindas ao cliente',
    contactDetails: 'Detalhes do contato',
    streetAddress: 'Endereço',
    streetAddress2: 'Endereço 2',
    city: 'Cidade',
    zipCode: 'CEP/Código Postal',
    customerSupport: 'Contatos de Suporte ao Cliente',
    country: 'País',
    state: 'Estado/Província',
    contactOwnerDescription: 'para o responsável pelo sistema / proprietário da casa entrar em contato',
    businessContacts: 'Contatos comerciais',
    sameCheckbox: 'Igual ao suporte ao cliente',
    contactEnphaseDescription: 'para que a Enphase entre em contato',
    installationDetails: 'Detalhes de instalação',
    servicesOffered: 'Serviços oferecidos',
    installationType: 'Tipo de instalação',
    salesEmployeeNumber: 'Número de funcionários em vendas',
    workmanshipWarranty: 'Garantia de mão de obra oferecida (ano)',
    installationEmployeeNumber: 'Número de funcionários fazendo instalações',
    typicalInstallationsYear: 'Instalações típicas (por ano)',
    typicalInstallationsMonth: 'Instalações típicas (kW / mês)',
    enphaseShare: 'Enphase Share nas instalações',
    sgipDeveloper: 'Você é um desenvolvedor SGIP?',
    sgipDeveloperTooltip: 'Selecione se você está registrado como um desenvolvedor SGIP em selfgenca.com',
    fein_ein: 'FEIN/EIN',
    sgipDeveloperKey: 'Chave de desenvolvedor SGIP',
    businessLicenses: 'Licenças de Negócios',
    addNewLicense: 'ADICIONE NOVA LICENÇA',
    licenseType: 'Tipo de licença',
    licenseNo: 'Nº da licença',
    none: 'Nenhum',
    licensingBoard: 'Conselho de Licenciamento',
    licensingAuthority: 'Autoridade de licenciamento',
    expiryDate: 'Data de validade',
    profileLinks: 'Links de perfil',
    yelpAccountLink: 'Link da conta do Yelp',
    rating: 'Notas',
    reviews: 'Avaliações',
    yelpAccountLinkTooltip:
      'Para obter este link, vá ao seu perfil Yelp e copie o link/URL na barra de endereços do seu navegador de internet',
    yelpAccountLinkError:
      'Não foi possível obter seu perfil yelp. Verifique novamente o link do perfil inserido por você',
    googlePlaceId: 'ID do Google Place',
    clickHere: 'Clique aqui',
    findPlaceId: 'para encontrar o seu ID do Google Place',
    placeIdError:
      'Não foi possível encontrar um local válido para este ID. Verifique novamente o ID inserido por você.',
    solarProfileLink: 'Link do perfil SolarReviews',
    solarProfileLinkTooltip:
      'Para obter este link, vá ao seu perfil SolarReviews.com e copie o link/URL na barra de endereços do seu navegador de internet',
    bbbProfileLink: 'Link do perfil BBB',
    bbbProfileLinkTooltip:
      'Para obter este link, vá ao seu perfil BBB.org e copie o link/URL na barra de endereços do seu navegador de internet',
    solarQuotesProfileLink: 'Link do perfil Solarquotes',
    solarQuotesTooltip:
      'Para obter este link, vá para o seu perfil solarquotes.com.au e copie o link/URL na barra de endereços do seu navegador de internet',
    productReviewProfileLink: 'Link do perfil do ProductReview',
    productReviewTooltip:
      'Para obter este link, vá ao seu perfil productreview.com.au e copie o link/URL na barra de endereços do seu navegador de internet',
    trustPilotLink: 'Link do perfil da Trustpilot',
    trustPilotTooltip:
      'Para obter este link, vá ao seu perfil trustpilot.com e copie o link / URL na barra de endereços do seu navegador de internet',
    facebookLink: 'Link do perfil do Facebook',
    facebookTooltip:
      'Para obter este link, vá ao seu perfil facebook.com e copie o link/URL na barra de endereços do seu navegador de internet',
    justDialLink: 'Basta discar o link do perfil',
    justDialTooltip:
      'Para obter este link, vá ao seu perfil justdial.com e copie o link/URL na barra de endereços do seu navegador de internet',
    listOfReferenceSystems: 'Lista de Sistemas de Referência',
    referenceListDescription:
      'Sua lista de referência é atualizada automaticamente para mostrar os sistemas que os responsáveis optaram por compartilhar. Os sistemas listados têm pelo menos 100 kWh de energia vitalícia.',
    requestSystemAccess: 'Solicitar acesso ao sistema',
    maintainer: 'Mantenedor',
    view_only: 'Apenas visualização',
    linkRequestAccess:
      'Envie este link aos responsáveis pelo sistema para solicitar acesso ao seu sistema no Enlighten.',
    fieldRequired: 'Este campo é obrigatório.',
    validEmail: 'Por favor insira um endereço de e-mail válido.',
    validPhone: 'Digite um número válido de telefone.',
    supportContact: 'Preencha pelo menos um dos campos acima (Telefone/E-mail).',
    serviceRequired: 'É necessário pelo menos um tipo de serviço',
    installationRequired: 'Pelo menos um tipo de instalação é necessário',
    minLength: 'O comprimento mínimo permitido é 2',
    maxLength: 'O comprimento máximo permitido é 15',
    dateWarning: 'Aviso - Esta licença será considerada como expirada, pois a data de expiração já passou',
    correctValue: 'Insira um valor menor ou igual a,',
    feinLength: 'Insira um número de 9 dígitos',
    less_than_25: 'Menos de 25%',
    between_25_50: '25% a 50%',
    between_50_90: '50% a 90%',
    greater_than_90: 'Maior que 90%',
    roofingFr: 'QualiPV Bâtiment',
    solarFr: 'QualiPV Electricité (inférieur ou égale à 36kVA)',
    storageFr: 'QualiPV Electricité (supérieur à 36kVA ou inférieur ou égale à 250kVA)',
    electricalFr: 'QualiPV Electricité (supérieur à 250kVA)',
    othersFr: 'Autres',
    roofing: 'Cobertura',
    solar: 'Solar',
    storage: 'Armazenar',
    electrical: 'Elétrica',
    ev_charger: 'Carregador EV',
    others: 'Outros',
    commercial: 'Comercial',
    residential: 'Residencial',
    new_homes: 'Novas Casas',
    installer: 'Instaladora',
    roles_distributor: 'Distribuidora',
    roles_support: 'Empresa de Apoio',
    cec: 'CEC',
    electrical_contract: 'Contrato de Eletricidade',
    abn_number: 'Número ABN',
    acn_number: 'Número ACN',
    installateurverzeichniss_elektro_eintrag: 'Installateurverzeichniss Elektro Eintrag',
    sgze: 'SGZE',
    zonnekeur: 'Zonnekeur',
    holland_solar: 'Holland Solar',
    techniek_nederland: 'Techniek Nederland',
    installq: 'InstallQ',
    fedelec: 'Fedelec',
    pv_vlaanderen: 'PV Vlaanderen',
    selectCountry: 'Selecione o país',
    yellowPageLink: 'Link da página amarela',
    yellowPageTooltip: undefined,
    enrQualityDirectoryLink: 'Annuary Qualit’Enr',
    enrQualityDirectoryTooltip: undefined,
    validChamberNumber: 'Entrada inválida! O número da Câmara de Comércio tem de ter, pelo menos, 8 carateres',
    chamberofcommerce : 'Número da Câmara de Comércio',
  }
};

export default company;
